export default __webpack_public_path__ + "static/media/Front-Private-Villa-in-Ankoun.4ba4e209.jpg";